import { TextAreaProps } from 'antd/lib/input'

export const IssueResolutionTextAreaOptions: TextAreaProps = { maxLength: 2000 }
